<template>
  <div class="flex flex-col mt-24 mx-16">
    <h2 class="uppercase lg:my-4 lg:text-4xl">Listado de productos de Salud</h2>
    <div class="flex row-reverse ml-auto">
      <span class="material-icons my-auto mx-4">search</span>
      <input
        type="text"
        class="border-2 rounded-lg p-1 border-gray-2 my-4 font-bold"
        v-model="searchQuery"
      />
    </div>
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div
          class="shadow overflow-hidden border-b border-gray-2 sm:rounded-lg"
        >
          <table class="min-w-full divide-y divide-gray-2">
            <thead class="bg-gray">
              <tr>
                <th
                  scope="col"
                  class="
                    px-6
                    py-3
                    text-left text-xs
                    font-bold
                    text-primary
                    uppercase
                  "
                >
                  Productos
                </th>
                <th
                  scope="col"
                  class="
                    flex
                    px-6
                    py-3
                    text-center text-xs
                    font-bold
                    text-primary
                    uppercase
                    tracking-wider
                  "
                >
                  <p class="mx-auto">Stock Cios</p>
                </th>
                <th
                  scope="col"
                  class="
                    px-6
                    py-3
                    text-center text-xs
                    font-bold
                    text-primary
                    uppercase
                    tracking-wider
                  "
                >
                  <p class="mx-auto">Stock Caracas</p>
                </th>
                <th
                  scope="col"
                  class="relative px-2 md:px-6 py-3 text-xs uppercase"
                >
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody class="bg-secondary divide-y divide-gray-2">
              <tr v-for="item in itemsSalud" :key="item.id">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div class="flex-shrink-0 h-10 w-10">
                      <img
                        class="h-10 w-10 rounded-full"
                        :src="item.link"
                        alt="I"
                      />
                    </div>
                    <div class="ml-4">
                      <div class="text-sm font-bold text-primary max-w-sm">
                        {{ item.name }}
                      </div>
                      <div class="text-sm text-primary truncate max-w-sm">
                        {{ item.desc }}
                      </div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap h-full my-auto">
                  <div class="flex">
                    <span
                      v-if="
                        item.cantidad != null &&
                        item.cantidad != undefined &&
                        item.cantidad > 0
                      "
                      class="
                        mx-auto
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-wasap-1
                        text-secondary
                        my-auto
                      "
                    >
                      {{ item.cantidad }}
                    </span>
                    <span
                      v-else
                      class="
                        mx-auto
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-red
                        text-secondary
                        my-auto
                      "
                    >
                      0
                    </span>
                  </div>
                </td>
                <td class="mx-auto py-4 whitespace-nowrap h-full my-auto">
                  <div class="flex">
                    <span
                      v-if="
                        item.cantidad2 != null &&
                        item.cantidad2 != undefined &&
                        item.cantidad2 > 0
                      "
                      class="
                        mx-auto
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-wasap-1
                        text-secondary
                        my-auto
                      "
                    >
                      {{ item.cantidad2 }}
                    </span>
                    <span
                      v-else
                      class="
                        mx-auto
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-red
                        text-secondary
                        my-auto
                      "
                    >
                      0
                    </span>
                  </div>
                </td>
                <td
                  class="
                    my-auto
                    mx-auto
                    px-6
                    py-4
                    whitespace-nowrap
                    text-right text-sm
                    font-bold
                    space-x-8
                  "
                >
                  <div class="flex space-x-4">
                    <!-- <a
                      @click="EditArt(item)"
                      href="#"
                      class="mx-auto my-auto text-primary hover:text-wasap-2"
                      >Editar</a
                    > -->
                    <a v-if="false"
                      @click="DelArt(item)"
                      href="#"
                      class="mx-auto my-auto text-primary hover:text-red"
                      >Eliminar</a
                    >
                    <router-link :to="'/Salud/'+item.id+'/'" class="mx-auto my-auto text-primary hover:text-wasap-2">
                      Ver Detalle
                    </router-link>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <tr
            v-if="itemsSalud.length == 0 && searchQuery != ''"
            class="flex w-full"
          >
            <h1 class="mx-auto my-8 flex text-2xl text-red">
              No se han encontrado resultados
            </h1>
          </tr>
        </div>
      </div>
    </div>
    <nav
      v-if="searchQuery == '' && getSalud != null"
      class="
        mx-auto
        my-8
        relative
        z-0
        inline-flex
        rounded-md
        shadow-sm
        -space-x-px
      "
      aria-label="Pagination"
    >
      <a
        @click="pageLeft()"
        class="
          relative
          inline-flex
          items-center
          px-2
          py-2
          rounded-l-md
          border border-primary
          bg-secondary
          text-sm text-gray-500
          delay-400
          hover:bg-primary hover:text-secondary
        "
      >
        <span class="material-icons">arrow_back</span>
      </a>
      <a
        v-for="n in parseInt(getSalud.length / itemxpage - 1)"
        :class="activePage"
        :id="`nav-tab-${i}`"
        :key="n"
        aria-current="page"
        @click="onNavClick(n)"
        class="
          z-10
          bg-indigo-50
          border-indigo-500
          text-indigo-600
          relative
          inline-flex
          items-center
          px-4
          py-2
          border
          text-sm
          font-medium
          transition
          duration-500
        "
        :style="
          n != paginaActiva
            ? 'border: 1px solid;'
            : 'border: none; font-weight: bold; color: white; background: black;'
        "
      >
        {{ n }}
      </a>
      <a
        @click="pageRigth()"
        class="
          relative
          inline-flex
          items-center
          px-2
          py-2
          rounded-r-md
          border border-gray-300
          bg-white
          text-sm
          font-medium
          text-gray-500
          hover:bg-gray-50
        "
      >
        <span class="material-icons">arrow_forward</span>
      </a>
    </nav>
    <CardModal :showing="isEdit" v-on:close="isEdit = false; itemEdit = {};">
      <div id="form" class="w-full max-w-lg p-2 mx-auto mt-2">
        <h1 class="uppercase text-md md:text-2xl">Editar producto de salud</h1>
        <img
          class="h-40 m-2 w-full object-contain rounded"
          :src="itemEdit.link"
          alt="I"
        />
        <div class="flex flex-wrap -mx-3 mb-6 md:mb-1">
          <div class="w-full md:w-full px-3 mb-6 md:mb-0">
            <label
              class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              for="grid-first-name"
            >
              Nombre
            </label>
            <input
              class="
                appearance-none
                block
                w-full
                bg-gray-200
                text-gray-700
                border border-red-500
                rounded
                py-3
                px-4
                mb-3
                leading-tight
                focus:outline-none focus:bg-white
              "
              id="grid-first-name"
              type="text"
              :placeholder="itemEdit.name"
              v-model="name"
            />
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-6 md:mb-1">
          <div class="w-full px-3">
            <label
              class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
              for="grid-password"
            >
              DescripciÓn
            </label>
            <textarea
              rows="12"
              class="
                appearance-none
                block
                w-full
                bg-gray-200
                text-gray-700
                border border-gray-200
                rounded
                py-3
                px-4
                mb-3
                leading-tight
                focus:outline-none focus:bg-white focus:border-gray-500
              "
              id="grid-description"
              type="text"
              :placeholder="itemEdit.desc"
              v-model="itemEdit.desc"
            ></textarea>
          </div>
        </div>
        <div class="w-full flex flex-wrap">
          <div class="w-full md:w-1/2 px-2 flex flex-col">
            <label
              class="
                block
                flex flex-row
                uppercase
                tracking-wide
                text-xs
                font-bold
                mb-2
              "
              for="grid-zip"
            >
              Cantidad (Stock Cios)
            </label>
            <div class="flex flex-row mx-auto">
              <button class="focus:outline-none" @click="restar">
                <span class="material-icons my-auto p-1 text-2xl text-primary"
                  >remove_circle</span
                >
              </button>
              <input
                class="
                  appearance-none
                  block
                  w-1/4
                  bg-gray-200
                  text-gray-700
                  border border-gray-200
                  rounded
                  my-2
                  py-3
                  px-4
                  leading-tight
                  focus:outline-none focus:bg-white focus:border-gray-500
                "
                id="grid-zip"
                type="number"
                :placeholder="calculo"
                v-model="numerito"
              />
              <span class="my-auto text-3xl" v-if="false">{{ calculo }}</span>

              <button class="focus:outline-none" @click="sumar">
                <span class="material-icons my-auto p-1 text-2xl text-primary"
                  >add_circle</span
                >
              </button>
            </div>
          </div>
          <div class="w-full md:w-1/2 px-2 flex flex-col">
            <label
              class="
                block
                flex flex-row
                uppercase
                tracking-wide
                text-xs
                font-bold
                mb-2
              "
              for="grid-zip"
            >
              Cantidad (Stock Caracas)
            </label>
            <div class="flex flex-row mx-auto">
              <button class="focus:outline-none" @click="restar2">
                <span class="material-icons my-auto p-1 text-2xl text-primary"
                  >remove_circle</span
                >
              </button>
              <input
                class="
                  appearance-none
                  block
                  w-1/4
                  bg-gray-200
                  text-gray-700
                  border border-gray-200
                  rounded
                  my-2
                  py-3
                  px-4
                  leading-tight
                  focus:outline-none focus:bg-white focus:border-gray-500
                "
                id="grid-zip"
                type="number"
                :placeholder="calculo2"
                v-model="numerito2"
              />
              <span class="my-auto text-3xl" v-if="false">{{ calculo2 }}</span>

              <button class="focus:outline-none" @click="sumar2">
                <span class="material-icons my-auto p-1 text-2xl text-primary"
                  >add_circle</span
                >
              </button>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/2 mb-6 md:mb-0 md:my-2" v-if="false">
          <label
            class="block uppercase tracking-wide text-xs font-bold mb-2"
            for="grid-zip"
          >
            Material
          </label>
          <input
            class="
              appearance-none
              block
              w-full
              bg-gray-200
              text-gray-700
              border border-gray-200
              rounded
              py-3
              px-4
              leading-tight
              focus:outline-none focus:bg-white focus:border-gray-500
            "
            id="grid-zip"
            type="text"
            :placeholder="itemEdit.material"
            v-model="material"
          />
        </div>
        <div class="w-full md:w-1/2 -px-3 mb-6 md:my-2" v-if="false">
          <label
            class="
              block
              uppercase
              tracking-wide
              text-gray-700 text-xs
              font-bold
              mb-2
            "
            for="grid-state"
          >
            Talla
          </label>
          <select
            class="
              block
              appearance-none
              w-full
              bg-secondary
              border border-primary
              text-primary
              py-3
              px-4
              pr-8
              rounded
              leading-tight
              focus:outline-none focus:text-primary
            "
            v-model="talla"
            selected
          >
            <option value="" class="text-opacity-50">
              Selecciona una opción
            </option>
            <option>XS</option>
            <option>S</option>
            <option>M</option>
            <option>L</option>
            <option>XL</option>
          </select>
        </div>
        <div class="w-full items-center justify-center flex">
          <img :src="imageUrl" style="max-height: 6rem" class="m-2" />
        </div>
        <div class="md:flex md:items-center">
          <input
            type="file"
            style="display: none"
            ref="fileInput"
            accept="image/*"
            @change="onFilePicked"
          />
          <div class="md:w-2/3 flex justify-center md:justify-start">
            <button
              class="
                shadow
                bg-primary
                hover:bg-purple-400
                focus:shadow-outline focus:outline-none
                text-secondary
                font-bold
                py-2
                px-4
                rounded
              "
              type="button"
              @click="onPickFile"
            >
              <div class="flex">
                Imagen
                <span class="material-icons text-secondary mx-1"
                  >attachment</span
                >
              </div>
            </button>
          </div>
        </div>
        <div class="flex items-center justify-center mb-6">
          <button
            class="
              shadow
              mx-1
              focus:shadow-outline focus:outline-none
              text-secondary
              font-bold
              py-2
              px-4
              rounded
              mt-2
            "
            type="button"
            @click="isEdit = false; itemEdit = {};"
            style="background: #f56565"
          >
            Cancelar
          </button>
          <button
            class="
              shadow
              mx-1
              bg-primary
              hover:bg-purple-400
              focus:shadow-outline focus:outline-none
              text-secondary
              font-bold
              py-2
              px-4
              rounded
              mt-2
            "
            type="button"
            @click="onSaveChanges"
          >
            Editar
          </button>
        </div>
      </div>
    </CardModal>
    <CardModal :showing="isDel" v-on:close="isDel = false; itemEdit = {};">
      <div>
        <h2 class="w-full text-center text-lg md:text-2xl">
          Eliminar este Producto?
        </h2>
        <div class="w-full justify-center items-center flex">
          <button
            class="
              shadow
              mx-1
              focus:shadow-outline focus:outline-none
              text-secondary
              font-bold
              py-2
              px-4
              rounded
              mt-2
            "
            type="button"
            @click="isDel = false; itemEdit = {};"
            style="background: #f56565"
          >
            Cancelar
          </button>
          <button
            class="
              shadow
              mx-1
              bg-primary
              hover:bg-purple-400
              focus:shadow-outline focus:outline-none
              text-secondary
              font-bold
              py-2
              px-4
              rounded
              mt-2
            "
            type="button"
            @click="onDelete()"
          >
            Eliminar
          </button>
        </div>
      </div>
    </CardModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CardModal from "@/components/shared/CardModal.vue";

export default {
  components: {
    CardModal,
  },
  data() {
    return {
      pagina: 0,
      paginaActiva: 1,
      itemxpage: 10,
      searchQuery: "",
      isEdit: false,
      isDel: false,
      itemEdit: {},
      talla: "",
      name: "",
      desc: "",
      coleccion: "",
      material: "",
      image: null,
      imageUrl: "",
      cantidad: 0,
      numerito: "",
      cantidad2: 0,
      numerito2: "",
    };
  },
  methods: {
    ...mapActions(["loadSalud", "editSalud", "delSalud"]),
    onNavClick(n) {
      this.pagina = +parseInt(n * this.itemxpage);
      this.paginaActiva = n;
    },
    pageLeft() {
      if (parseInt(this.paginaActiva) > 1) {
        this.pagina = this.pagina - parseInt(this.itemxpage);
        this.paginaActiva = this.paginaActiva - 1;
      }
    },
    pageRigth() {
      if (
        this.getSalud != null &&
        parseInt(this.paginaActiva) < this.getSalud.length / this.itemxpage - 1
      ) {
        this.pagina = this.pagina + parseInt(this.itemxpage);
        this.paginaActiva = this.paginaActiva + 1;
      }
    },
    EditArt(item) {
      this.isEdit = true;
      this.itemEdit = item;
    },
    DelArt(item){
      this.isDel = true;
      this.itemEdit = item;
    },
    onSaveChanges() {
      /*if (this.name.trim() === '' || this.desc.trim() === '' ) {
                return
            }*/
      this.editSalud({
        id: this.itemEdit.id,
        name: this.name,
        desc: this.itemEdit.desc,
        image: this.image,
        cantidad: parseInt(this.calculo),
        cantidad2: parseInt(this.calculo2),
        antigua: parseInt(this.itemEdit.cantidad),
        antigua2: parseInt(this.itemEdit.cantidad2),
      });
      this.isEdit = false;
      this.cantidad = 0;
      this.cantidad2 = 0;
      this.itemEdit = {};
      this.loadSalud();
    },
    /*onDelete() {
      this.delSalud(this.id);
      this.$router.push("/tienda");
    },*/
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
    },
    sumar() {
      if (this.numerito != "") {
        this.numerito = parseInt(this.numerito) + 1;
        this.cantidad = 0;
      } else {
        this.cantidad = this.cantidad + 1;
        this.numerito = "";
      }
    },
    restar() {
      if (this.numerito != "") {
        this.numerito = parseInt(this.numerito) - 1;
        this.cantidad = 0;
      } else {
        this.cantidad = this.cantidad - 1;
        this.numerito = "";
      }
    },
    sumar2() {
      if (this.numerito2 != "") {
        this.numerito2 = parseInt(this.numerito2) + 1;
        this.cantidad2 = 0;
      } else {
        this.cantidad2 = this.cantidad2 + 1;
        this.numerito2 = "";
      }
    },
    restar2() {
      if (this.numerito2 != "") {
        this.numerito2 = parseInt(this.numerito2) - 1;
        this.cantidad2 = 0;
      } else {
        this.cantidad2 = this.cantidad2 - 1;
        this.numerito2 = "";
      }
    },
    onDelete() {
      this.delSalud(this.itemEdit.id);
      this.isDel = false;
      this.itemEdit = {}
      /*this.$router.push("/tienda");*/
      this.loadSalud();
    },
  },
  beforeMount() {
    this.loadSalud();
  },
  computed: {
    ...mapGetters(["getSalud"]),
    itemsSalud() {
      if (this.getSalud != null && this.getSalud.length > 0)
        if (this.searchQuery != "") {
          return this.getSalud.filter((item) => {
            return this.searchQuery
              .toLowerCase()
              .split(" ")
              .every((v) => item.name.toLowerCase().includes(v));
          });
        } else {
          return this.getSalud.slice(this.pagina, this.pagina + this.itemxpage);
        }
      else return [{ name: "Cargando" }];
    },
    calculo() {
      if (!this.itemEdit.cantidad) {
        if (this.numerito == "") return this.cantidad;
        else return this.numerito;
      } else {
        if (this.numerito == "")
          return parseInt(this.itemEdit.cantidad) + this.cantidad;
        else return this.numerito;
      }
    },
    calculo2() {
      if (!this.itemEdit.cantidad2) {
        if (this.numerito2 == "") return this.cantidad2;
        else return this.numerito2;
      } else {
        if (this.numerito2 == "")
          return parseInt(this.itemEdit.cantidad2) + this.cantidad2;
        else return this.numerito2;
      }
    },
  },
};
</script>

<style scoped>
p,
h2,
h1,
a,
th,
tr {
  font-family: "Montserrat", serif;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>